import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Player from '@vimeo/player';
import { parseVimeoUrl } from '../utils/vimeo';

export default class Vimeo extends React.Component {

  static propTypes = {
    url: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    vimeoOptions: PropTypes.object,
  }

  static defaultProps = {
    color: 'ec4e47',
    vimeoOptions: {},
  }

  // Vimeo player.js accepts either { id } or { url }; prefer the URL so the
  // privacy hash of unlisted videos survives.
  sourceOption = () => {
    if (this.props.id) return { id: this.props.id };
    const { id, url } = parseVimeoUrl(this.props.url);
    return url ? { url } : { id };
  }

  _initPlayer = () => {
    if (this.player) {
      this.player.unload();
    }
    if (this.video && this.video instanceof HTMLElement) {
      const { color, vimeoOptions } = this.props;
      // Pass the full URL, not the bare id: unlisted videos need the privacy
      // hash (https://vimeo.com/<id>/<hash>) to pass Vimeo's oEmbed check.
      this.player = new Player(this.video, {
        ...this.sourceOption(),
        color,
        ...vimeoOptions,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.url !== this.props.url) || (prevProps.id && this.props.id && prevProps.id !== this.props.id)) {
      if (this.player) {
        const { url, id } = this.sourceOption();
        this.player.loadVideo(url || id);
      }
    }
  }

  componentDidMount() {
    this._initPlayer();
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.unload();
    }
  }

  render() {
    return (
      <div className={`${this.props.className}`} ref={ref => this.video = ref} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Vimeo.js